import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { COLOR_SELECT_ROW_GANT, HEIGHT_ITEM, STROKE_PARAM } from '../const';
import { getScreenViewVertical } from '../functions';
import { RootState } from '../store';
import { ItemType, MappingItemIdIndexType } from '../types';

interface IGantGridRow {}

const GantGridRowSelectItem: React.FC<IGantGridRow> = () => {
    const currentScrollY = useSelector<RootState, number>((state) => state.gantScroll.currentScrollY);
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const availableHeight = useSelector<RootState, number>((state) => state.gant.availableHeight);

    const { start, end } = getScreenViewVertical(currentScrollY, availableHeight);

    const renderRowLine = useMemo(() => {
        const listItem = currentGantItem ? itemsList[mappingItemIdIndex[currentGantItem.id]] : null;
        if (!listItem) {
            return null;
        }

        const ind = (currentGantItem?.idIndex || 0) + 1;

        return (
            <>
                {!listItem.hideForCollapse && (
                    <g key={'line' + ind} style={{ pointerEvents: 'none', mixBlendMode: 'normal' }}>
                        <rect
                            x={0}
                            y={(ind - 1) * HEIGHT_ITEM}
                            width="100%"
                            height={HEIGHT_ITEM}
                            fill={COLOR_SELECT_ROW_GANT}
                            opacity={0.1}
                        />
                        <line x1={0} y1={ind * HEIGHT_ITEM} x2="100%" y2={ind * HEIGHT_ITEM} {...STROKE_PARAM} />
                    </g>
                )}
            </>
        );
    }, [currentGantItem, itemsList, start, end]);

    return <>{renderRowLine}</>;
};

export default GantGridRowSelectItem;
